















































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import AuditKepatuhanPpiService from "@/services/AuditKepatuhanPpiService";
import AuditKepatuhanPpiItemLogger from "./AuditKepatuhanPpiItemLogger.vue";
import AuditKepatuhanPpiDetail from "./AuditKepatuhanPpiDetail.vue";
import { METODE_AUDIT_OPTIONS } from "@/constants/seksiAuditKepatuhanPpi";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

@Component({
  components: { AuditKepatuhanPpiItemLogger, AuditKepatuhanPpiDetail, UnitRuangPicker, PersonAutoComplete }
})
export default class AuditKepatuhanPpiList extends Vue {
  mode: "list" | "create" | "logger" | "detail" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;

  metodeOptions = METODE_AUDIT_OPTIONS;

  form: any = this.emptyForm();

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "TTD Auditor", value: "submitted" },
    { text: "Diperiksa Ketua PPI", value: "verified_ketua_ppi" },
    { text: "Disetujui Ka. Unit", value: "approved_kaunit" },
    { text: "Disetujui Direktur", value: "approved_direktur" },
    { text: "Closed", value: "closed" }
  ];

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 },
    { text: "Maret", value: 3 }, { text: "April", value: 4 },
    { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 },
    { text: "September", value: 9 }, { text: "Oktober", value: 10 },
    { text: "November", value: 11 }, { text: "Desember", value: 12 }
  ];

  headers = [
    { text: "Nomor", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_audit" },
    { text: "Ruang / Instalasi", value: "unit_nama" },
    { text: "% Patuh", value: "compliance_rate_total" },
    { text: "Kategori", value: "kategori_kepatuhan" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", sortable: false, width: 120 }
  ];

  emptyForm() {
    return {
      unit_id: "",
      unit_nama: "",
      tanggal_audit: "",
      waktu_mulai: "",
      metode_audit: "observasi_langsung",
      periode_bulan: new Date().getMonth() + 1,
      periode_tahun: new Date().getFullYear(),
      auditor_nama: "",
      auditor_sip_str: "",
      auditor_jabatan: "Komite PPI"
    };
  }

  get canCreate(): boolean {
    return !!(
      this.form.unit_id &&
      this.form.tanggal_audit &&
      this.form.metode_audit &&
      this.form.periode_bulan &&
      this.form.periode_tahun
    );
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      const res = await AuditKepatuhanPpiService.getList({ params });
      this.sessions = res.data.data.data || res.data.data;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.mode = "create";
    this.form = this.emptyForm();
    const today = localISODate();
    this.form.tanggal_audit = today;
    this.form.waktu_mulai = new Date().toTimeString().slice(0, 5);
    this.form.periode_bulan = new Date().getMonth() + 1;
    this.form.periode_tahun = new Date().getFullYear();
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async createSession() {
    if (!this.canCreate) return;
    this.creating = true;
    try {
      const res = await AuditKepatuhanPpiService.create(this.form);
      const sess = res.data.data;
      this.currentSessionId = sess.id;
      this.mode = "logger";
    } finally {
      this.creating = false;
    }
  }

  openLogger(item: any) {
    this.currentSessionId = item.id;
    this.mode = "logger";
  }

  openDetail(item: any) {
    this.currentSessionId = item.id;
    this.mode = "detail";
  }

  async returnToList() {
    this.mode = "list";
    await this.loadData();
  }

  printPdf(id: number) {
    AuditKepatuhanPpiService.printPdf(id);
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  getComplianceColor(rate: number) {
    if (!rate && rate !== 0) return "grey";
    if (rate >= 85) return "success";
    if (rate >= 76) return "warning";
    return "error";
  }
}
